import { useMutation, useQueryClient } from 'react-query';
import { can } from '../../permissions';
import { usePortal } from './hooks';
import { saveSelectionConfiguration } from './registrationConfiguration';

export default function useSaveSelectionConfiguration(selection) {
  const { faculdade, token, user } = usePortal();
  const cache = useQueryClient();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const mutation = useMutation(
    (data) => {
      if (!allowed) throw new Error('Você não possui permissão para editar esta configuração.');
      return saveSelectionConfiguration({ organization: faculdade, token, selection, data });
    },
    { onSettled: () => cache.invalidateQueries(['portal', faculdade, user?.id]) }
  );
  return { ...mutation, allowed };
}
